import React,{useState,useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import Input from '../Components/Input.js'
import Button from '../Components/Button.js'
import {use} from '../Helpers.js'
import {call} from '../Methods.js'
import {ValidateInput} from '../ValidationDefaults.js'

function Logout () {
document.title = 'Çıxış...'
const [loading,setLoading] = useState(false)
const navigate = useNavigate();

useEffect(()=>{
  handleLogout();
},[])
const handleLogout = async e => {

  localStorage.removeItem('cm_token')
  navigate('/login',{replace:true})
}

  return (
    <></>
  )
}

export default Logout